import AirDatepicker from 'air-datepicker';
import localesFr from 'air-datepicker/locale/fr';

class Filters {
  constructor() {
    this._initDatePicker();
    this._initToggle();
  }

  private _initToggle() {
    const toggleButton = document.querySelector('.filters-toggle');
    const filtersForm = document.querySelector('.filters');
    const overlay = document.querySelector('.filters-overlay');
    const closeButton = document.querySelector('.filters__close');

    if (toggleButton && filtersForm && overlay && closeButton) {
      toggleButton.addEventListener('click', () => {
        filtersForm.classList.add('modal-open');
        overlay.classList.add('modal-open');
        document.body.style.overflow = 'hidden';
      });

      closeButton.addEventListener('click', () => {
        filtersForm.classList.remove('modal-open');
        overlay.classList.remove('modal-open');
        document.body.style.overflow = '';
      });

      overlay.addEventListener('click', () => {
        filtersForm.classList.remove('modal-open');
        overlay.classList.remove('modal-open');
        document.body.style.overflow = '';
      });
    }
  }

  _initDatePicker() {
    const displayInput = document.getElementById('select-date-display');
    const hiddenInput = document.getElementById('select-date');

    if (displayInput && hiddenInput) {
      const selectedDates: Date[] = [];

      const dataDate = hiddenInput.getAttribute('data-date');
      const dataDateDebut = hiddenInput.getAttribute('data-date-debut');
      const dataDateFin = hiddenInput.getAttribute('data-date-fin');

      if (dataDate) {
        selectedDates.push(this._parseDate(dataDate));
      } else if (dataDateDebut && dataDateFin) {
        selectedDates.push(this._parseDate(dataDateDebut), this._parseDate(dataDateFin));
      }

      const datepicker = new AirDatepicker(displayInput as HTMLInputElement, {
        locale: localesFr,
        range: true,
        buttons: [
          {
            content: 'Effacer',
            onClick: () => {
              (displayInput as HTMLInputElement).value = '-';
              (hiddenInput as HTMLInputElement).value = '';
              datepicker.clear();
            },
          },
        ],
        onSelect: ({ date }) => {
          if (Array.isArray(date)) {
            if (date.length === 1) {
              const selectedDate = date[0];
              this._setInitialValue(
                displayInput as HTMLInputElement,
                hiddenInput as HTMLInputElement,
                [selectedDate]
              );
            } else if (date.length === 2) {
              this._setInitialValue(
                displayInput as HTMLInputElement,
                hiddenInput as HTMLInputElement,
                date
              );
            }
          }
        },
      });

      if (selectedDates.length > 0) {
        this._setInitialValue(
          displayInput as HTMLInputElement,
          hiddenInput as HTMLInputElement,
          selectedDates
        );
        // TODO : Regarder pour présélectionner les dates dans le datepicker sans changer le format
        // datepicker.selectDate(selectedDates, { silent: true });
      }
    }
  }

  private _setInitialValue(
    displayInput: HTMLInputElement,
    hiddenInput: HTMLInputElement,
    dates: Date[]
  ) {
    if (dates.length === 1) {
      displayInput.value = `Le ${this._formatDate(dates[0])}`;
      hiddenInput.value = this._formatDateForQuery(dates[0]);
    } else if (dates.length === 2) {
      displayInput.value = `Du ${this._formatDate(dates[0])} au ${this._formatDate(dates[1])}`;
      hiddenInput.value = `${this._formatDateForQuery(dates[0])}au${this._formatDateForQuery(
        dates[1]
      )}`;
    } else {
      displayInput.value = '-';
      hiddenInput.value = '';
    }
  }

  private _formatDateForQuery(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}${month}${day}`;
  }

  private _parseDate(dateString: string): Date {
    const year = parseInt(dateString.substring(0, 4));
    const month = parseInt(dateString.substring(4, 6)) - 1;
    const day = parseInt(dateString.substring(6, 8));
    return new Date(year, month, day);
  }

  private _formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}

export const filters = new Filters();
